import { AppEnvironment, Environments } from '@core/models/environment.models';

export const environment: AppEnvironment = {
    version: '1.0.0',
    build: 100000,
    local: false,
    debug: true,
    production: false,
    apiUrl: 'https://api.dev.dartcounter.argo-ict.net',
    stage: Environments.Development,
    echo: {
        key: 'gw15jtm74slpgmfwyw3a',
        wsHost: 'wss-dev.dartcounter.net',
        wsPort: 443,
        wssPort: 443,
        scheme: 'https',
    },
    recaptcha: '6Ld0Zj8lAAAAAExqwkT4H9hPUwbX97k3_z8PdIXG',
};
